import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { AppBreadcrumbService } from 'src/app/services/app.breadcrumb.service';
import { AppConfig } from 'src/app/domain/appconfig';
import { TranslateService } from '@ngx-translate/core';
import { Direction, itemStockDetails, itemStockWithArray, Statuses, WarehouseService } from 'src/app/services/warehouse.service';
import { SortEvent } from 'primeng/api';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject, forkJoin, map } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { WarehouseCreateOrderModalComponent } from './warehouseCreateOrderModal/warehouseCreateOrderModal/warehouseCreateOrderModal.component';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class WarehouseComponent implements OnInit {
  @ViewChild("orderTable") dt;

  uploadedFiles: any[] = [];
  edi: any[] = [];
  WarehouseOrder$ = new BehaviorSubject<any[]>(this.warehouseService.WareHouseOrders$.value);
  orders: any[] = [];
  isSorted = false;
  config: AppConfig;
  itemStocks: itemStockWithArray[] = [];
  itemStock: any = {};
  loading: boolean = false;
  selectedDateRange = [this.buildStartDate(),new Date()];

  //#region dateselector prop
  minDate = new Date("01/01/1970")
  startDate = this.buildStartDate();
  endDate = new Date();
  //#endregion

  translatedStatus$ = new BehaviorSubject<{ label: string, guid: string }[]>(new Array<{ label: string, guid: string }>());

  constructor(private breadcrumbService: AppBreadcrumbService, private warehouseService: WarehouseService, private translateService: TranslateService, private dialogService: DialogService) {
    this.breadcrumbService.setItems([{ label: 'Lager hotel' }]);
    this.warehouseService.itemStockDetails$.subscribe(x => {
      if (x[0]) {
        let temp = this.itemStocks.find(ty => ty.id == x[0].itemId);
        if (temp) {
          temp.details = new Array<any>();
          x.forEach(y => {
            temp.details.push(y);
          })
        }

      }
    })
    this.warehouseService.WareHouseOrders$.subscribe(x => {
      if (x.length > 0) {
        let tempArr = new Array<{ label: string, guid: string }>();
        x.map(y => { return { label: y.status, guid: y.status } }).forEach(y => {
          if (tempArr.findIndex(i => i.guid == y.guid) == -1) {
            tempArr.push(y);
          }
        });
        this.translateService.get(tempArr.map(t => "WAREHOUSE.WAREHOUSEORDRE." + t.guid)).subscribe(ts => {
          this.translatedStatus$.next(tempArr.map(m => { return { label: ts["WAREHOUSE.WAREHOUSEORDRE." + m.label], guid: m.guid } }));
        })
      }
      this.ClearFilter();
    });
  }
  DateRangeSelectorEvent(value: any) {
    console.log("date Range: ", this.selectedDateRange)
  }

  ngOnInit(): void {
    this.loaddata();
    this.warehouseService.GetWareHouseOrders({ fromDate: this.selectedDateRange[0], toDate: this.selectedDateRange[1] });
  }

  buildStartDate() {
    let toDay = new Date();
    return new Date(toDay.getFullYear(), toDay.getMonth() - 1, toDay.getDate());
  }

  loaddata() {
    this.warehouseService.GetItemStocks().subscribe({   //, "ecbed7aa-d57d-4fb3-a3df-a3dc0bf81e9d"
      next: (res) => {
        this.itemStocks = res.filter(x => x.isDeleted == false) as itemStockWithArray[];
        this.itemStocks.forEach(y => y.details = new Array<itemStockDetails>())
        this.warehouseService.itemStocks$.next(res);
      },
    });
  }

  onRowSelect(item: any) {
    this.getWareHouseDetails(item);
  }

  GetdirectionByGuid(direction: string) {
    return Object.entries(Direction).find(([_, value]) => value === direction)?.[0];
  }

  orderSort(event: SortEvent) {
    if (this.isSorted == null || this.isSorted === undefined) {
      this.isSorted = true;
      this.sortTableData(event);
    } else if (this.isSorted == true) {
      this.isSorted = false;
      this.sortTableData(event);
    } else if (this.isSorted == false) {
      this.isSorted = null;
      this.orders = [...this.WarehouseOrder$.value];
      this.dt.reset();
    }
  }

  sortTableData(event) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;
      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });
  }

  FilterStatusSeleted(event: any) {

    if (event.value.length < 1) {
      this.ClearFilter();
    } else {
      let result = new Array<any>();
      event.value.forEach(guid => {
        this.warehouseService.WareHouseOrders$.value.filter(x => x.status == guid).forEach(x => result.push(x));
      });
      this.WarehouseOrder$.next(result)
    }
  }

  ClearFilter() {
    this.WarehouseOrder$.next(this.warehouseService.WareHouseOrders$.value);
  }

  DateSeltorEvent(event: any, isStartDate: boolean) {
    isStartDate ? this.startDate = event.event : this.endDate = event.event;
  }


  downloadCSV() {
    this.warehouseService.GetItemStocksCSV().subscribe({
      next: (res: any) => {
        if (res && res.labelUrl) {
          window.open(res.labelUrl);
        }
      },
    });
  }
  CreateOrdreModalOpen() {
    this.dialogService.open(WarehouseCreateOrderModalComponent, { height: "80%", width: "80%", data: { itemStocks: this.itemStocks } });
  }

  getWareHouseDetails(row: any) {
    if ((row.data.details && row.data.details.length > 0))
      return;
    this.warehouseService.GetItemStockDetails(row.data.id, true)
  }
  PerformSearch() {
    if (this.selectedDateRange[1])
      this.warehouseService.GetWareHouseOrders({ fromDate: this.selectedDateRange[0], toDate: this.selectedDateRange[1] })
  }

}
